<mat-card-actions>
    <button class="btn1"><i class="fa fa-pencil"></i></button>
    <button class="btn1"><i class="fa fa-play"></i></button>
    <button class="btn1"><i class="fa fa-pause"></i></button>
    <button class="btn1"><i class="fa fa-stop"></i></button>
    <button class="btn1"><i class="fa fa-plus"></i></button>
    <button class="btn1"><i class="fa fa-close"></i></button>
</mat-card-actions>-->